import '@ngrx/core/add/operator/select';

import {combineReducers} from '@ngrx/store';

import {appPrincipalReducer, INITIAL_USER_STATE} from './user.reducer';
import {appUiStateReducer, INITIAL_APP_UI_STATE} from './app-ui.reducer';

import {environment} from 'environments/environment';
import {storeFreeze} from 'ngrx-store-freeze';
import {MainState} from '@nw/ui-core-shared/store/main.store';

export const INITIAL_APPLICATION_STATE: MainState = {
  appPrincipal: INITIAL_USER_STATE,
  appUiState: INITIAL_APP_UI_STATE
};

const reducers = {
  appPrincipal: appPrincipalReducer,
  appUiState: appUiStateReducer
};

const reducer = environment.production
  ? combineReducers(reducers)
  : storeFreeze(combineReducers(reducers));

export function mainReducer(state = INITIAL_APPLICATION_STATE , action: any) {
  return reducer(state, action);
}



// WEBPACK FOOTER //
// ./src/main/angular/app/main-state/reducers/index.ts